import { c as _c } from "react/compiler-runtime";
import { cx } from 'class-variance-authority';
import { Command } from 'cmdk';
import type * as CSS from 'csstype';
type ComboItemProps = {
  children: React.ReactNode;
  value: string;
  /** Additional searchable strings forwarded to cmdk's Command.Item for filtering. */
  keywords?: string[];
  onSelect?: (value: string) => void;
  size?: 'compact' | 'default';
  height?: CSS.Property.Height;
  disabled?: boolean;
};
const ComboItem = t0 => {
  const $ = _c(23);
  let children;
  let disabled;
  let height;
  let onSelect;
  let props;
  let t1;
  let value;
  if ($[0] !== t0) {
    ({
      children,
      value,
      onSelect,
      size: t1,
      height,
      disabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = disabled;
    $[3] = height;
    $[4] = onSelect;
    $[5] = props;
    $[6] = t1;
    $[7] = value;
  } else {
    children = $[1];
    disabled = $[2];
    height = $[3];
    onSelect = $[4];
    props = $[5];
    t1 = $[6];
    value = $[7];
  }
  const size = t1 === undefined ? "default" : t1;
  let t2;
  if ($[8] !== height) {
    t2 = {
      height
    };
    $[8] = height;
    $[9] = t2;
  } else {
    t2 = $[9];
  }
  const t3 = size === "compact";
  const t4 = size === "default";
  const t5 = !disabled;
  let t6;
  if ($[10] !== disabled || $[11] !== t3 || $[12] !== t4 || $[13] !== t5) {
    t6 = cx("text-body-2 px-3 data-[selected=true]:bg-(--dropdown-hover-bg)", {
      "py-1": t3,
      "py-2": t4,
      "cursor-pointer hover:bg-hover": t5,
      "pointer-events-none cursor-[inherit] text-quaternary": disabled
    });
    $[10] = disabled;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== children || $[16] !== disabled || $[17] !== onSelect || $[18] !== props || $[19] !== t2 || $[20] !== t6 || $[21] !== value) {
    t7 = <Command.Item value={value} onSelect={onSelect} disabled={disabled} style={t2} className={t6} {...props}>{children}</Command.Item>;
    $[15] = children;
    $[16] = disabled;
    $[17] = onSelect;
    $[18] = props;
    $[19] = t2;
    $[20] = t6;
    $[21] = value;
    $[22] = t7;
  } else {
    t7 = $[22];
  }
  return t7;
};
export default ComboItem;